// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2J2-2","title":"AfterBackImages_title__3kkXG","images":"AfterBackImages_images__1Q9xf"};